import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import logo from '../assets/images/logo.png';
import makeIndia from '../assets/certifications/makeinindia.png';
import isoLogo from '../assets/certifications/iso.png';
import msmeLogo from '../assets/certifications/msme.png';
import iecLogo from '../assets/certifications/iec.png';
import CEIGLogo from '../assets/certifications/CEIG.png';
import SGSLogo from '../assets/certifications/SGS.png';
import Grade_ALogo from '../assets/certifications/Grade_A.png';

const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">

      <Container>

        <Row className="g-4">

          {/* Company Info */}

          <Col lg={4} md={6}>

            <div className="footer-brand mb-3">

              <div className="footer-brand-header">

                <div className="brand-left">
                  <img src={logo} alt="VPC Logo" className="footer-logo" />
                  <h5 className="mb-0">Vigneshwara Power Controls</h5>
                </div>

              </div>

            </div>

            <p className="mb-3 text-light">
              Leading electrical engineering company specializing in manufacturing,
              testing, commissioning, and servicing of industrial electrical panels
              and equipment.
            </p>

            {/* Visit Main Website */}

            <a
              href="https://vigneshwarapowercontrols.in"
              target="_blank"
              rel="noopener noreferrer"
              className="visit-main-btn"
            >
              Visit Main Website →
            </a>

            <img
              src={makeIndia}
              alt="Make in India"
              className="make-india-logo"
            />

            {/* Certifications */}

            <div className="footer-certifications">
              <img src={isoLogo} alt="ISO" />
              <img src={msmeLogo} alt="MSME" />
              <img src={iecLogo} alt="IEC" />
              <img src={CEIGLogo} alt="CEIG" />
              <img src={SGSLogo} alt="SGS" />
              <img src={Grade_ALogo} alt="Grade A" />
            </div>

          </Col>


          {/* Technical Resources */}

          {/* Why Choose Us */}

<Col lg={2} md={6}>

  <h5 className="mb-4">Why Choose Us</h5>

  <div className="footer-links">

    <p className="footer-text">Certified Electrical Solutions</p>
    <p className="footer-text">High Quality Manufacturing</p>
    <p className="footer-text">Experienced Engineering Team</p>
    <p className="footer-text">Industry Standard Compliance</p>
    <p className="footer-text">Reliable Technical Support</p>

  </div>

</Col>


          {/* Industries */}

          <Col lg={3} md={6}>

            <h5 className="mb-4">Industries We Serve</h5>

            <div className="footer-links">

              <p className="footer-industry">Power Plants</p>
              <p className="footer-industry">Cement Industries</p>
              <p className="footer-industry">Steel Industries</p>
              <p className="footer-industry">Manufacturing Plants</p>
              <p className="footer-industry">Infrastructure Projects</p>
              <p className="footer-industry">Commercial Facilities</p>

            </div>

          </Col>


          {/* Contact Info */}

          <Col lg={3} md={6}>

            <h5 className="mb-4">Contact Info</h5>

            <div className="footer-links">

              <p className="mb-3">

                <i className="bi bi-geo-alt me-2"></i>

                <strong>Vigneshwara Power Controls</strong><br />

                Building No. 275, Phase-1 & 2, Block No-16,<br />

                Near SBI Branch, Auto Nagar,<br />

                Guntur, Andhra Pradesh – 522001

              </p>

              <a
                href="https://maps.app.goo.gl/46R8jWtqKJctEJso7"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-map-link"
              >
                View on Google Maps
              </a>

              <p className="mb-2">
                <i className="bi bi-telephone me-2"></i>
                +91 73967 48509
              </p>

              <p className="mb-2">
                <i className="bi bi-envelope me-2"></i>
                info@vigneshwarapowercontrols.in
              </p>

            </div>

          </Col>

        </Row>

        {/* Footer Bottom */}

        <div className="footer-bottom">

          <p className="mb-0">
            &copy; {currentYear} Vigneshwara Power Controls. All Rights Reserved.
          </p>

        </div>

      </Container>

    </footer>
  );
};

export default Footer;